import { render, staticRenderFns } from "./Viz1IconStrategise.vue?vue&type=template&id=94824262&"
import script from "./Viz1IconStrategise.vue?vue&type=script&lang=js&"
export * from "./Viz1IconStrategise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports